
<template>
  <div class="">
    <div class="flex">
      <div class="w-full p-4 md:8 lg:p-16">
        <div class="w-full bg-white p-6 md:p-8 lg:p-12">
          <h2 class="text-3xl font-bold mb-6 text-left text-gray-800">
            Sign In
          </h2>
          <form @submit.prevent="login">
            <div class="flex justify-between text-[14px] items-center">
              <p
                v-if="showVerifyButton"
                @click="redirectToVerifyEmail"
                class="text-primaryDark hover:u px-3 py-1 bg-[#EEEEEE] rounded-md"
              >
                Verify Email
              </p>
            </div>
            <div class="mb-4">
              <label class="block text-sm font-medium text-gray-700"
                >Email</label
              >
              <input
                v-model="username"
                type="text"
                placeholder="Enter your email address"
                class="mt-1 block w-full px-3 py-2 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-[#F6F8F9]"
                required
              />
            </div>

            <div class="mb-6">
              <div class="flex justify-between">
                <label class="block text-sm font-medium text-gray-700"
                  >Password</label
                >
                <router-link
                  to="/forgot-password"
                  class="text-[#2F6DF7] underline text-sm"
                  >Forgot Password</router-link
                >
              </div>
              <div class="relative">
                <input
                  v-model="password"
                  :type="showPassword ? 'text' : 'password'"
                  placeholder="Enter your password"
                  class="mt-1 block w-full px-3 py-2 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-[#F6F8F9]"
                  required
                />
                <span
                  @click="togglePassword"
                  class="absolute inset-y-0 right-2 flex items-center cursor-pointer"
                >
                  <svg
                    v-if="showPassword"
                    xmlns="http://www.w3.org/2000/svg"
                    height="14"
                    width="14"
                    viewBox="0 0 24 24"
                  >
                    <title>hide</title>
                    <g
                      stroke-linejoin="miter"
                      fill="#212121"
                      stroke-linecap="butt"
                      class="nc-icon-wrapper"
                    >
                      <path
                        d="M1.373,13.183a2.064,2.064,0,0,1,0-2.366C2.946,8.59,6.819,4,12,4s9.054,4.59,10.627,6.817a2.064,2.064,0,0,1,0,2.366C21.054,15.41,17.181,20,12,20S2.946,15.41,1.373,13.183Z"
                        fill="none"
                        stroke="#212121"
                        stroke-linecap="square"
                        stroke-miterlimit="10"
                        stroke-width="2"
                      ></path>
                      <circle
                        data-color="color-2"
                        cx="12"
                        cy="12"
                        r="4"
                        fill="none"
                        stroke="#212121"
                        stroke-linecap="square"
                        stroke-miterlimit="10"
                        stroke-width="2"
                      ></circle>
                      <line
                        data-color="color-2"
                        x1="2"
                        y1="22"
                        x2="22"
                        y2="2"
                        fill="none"
                        stroke="#212121"
                        stroke-linecap="square"
                        stroke-miterlimit="10"
                        stroke-width="2"
                      ></line>
                    </g>
                  </svg>
                  <svg
                    v-else
                    xmlns="http://www.w3.org/2000/svg"
                    height="14"
                    width="14"
                    viewBox="0 0 24 24"
                  >
                    <title>view</title>
                    <g
                      stroke-linejoin="miter"
                      fill="#212121"
                      stroke-linecap="butt"
                      class="nc-icon-wrapper"
                    >
                      <path
                        d="M1.373,13.183a2.064,2.064,0,0,1,0-2.366C2.946,8.59,6.819,4,12,4s9.054,4.59,10.627,6.817a2.064,2.064,0,0,1,0,2.366C21.054,15.41,17.181,20,12,20S2.946,15.41,1.373,13.183Z"
                        fill="none"
                        stroke="#212121"
                        stroke-linecap="square"
                        stroke-miterlimit="10"
                        stroke-width="2"
                      ></path>
                      <circle
                        data-color="color-2"
                        cx="12"
                        cy="12"
                        r="4"
                        fill="none"
                        stroke="#212121"
                        stroke-linecap="square"
                        stroke-miterlimit="10"
                        stroke-width="2"
                      ></circle>
                    </g>
                  </svg>
                </span>
              </div>
            </div>
            <button
              type="submit"
              class="w-full py-2 px-4 bg-primaryDarkBg hover:bg-primaryDark text-white font-bold rounded"
              :disabled="loading"
            >
              <span v-if="loading" class="spinner"></span>
              <span v-else>Login</span>
            </button>
            <!-- <button
                    v-if="showVerifyButton"
                    @click="redirectToVerifyEmail"
                    class="w-full mt-4 py-2 px-4 bg-blue-500 hover:bg-blue-600 text-white font-bold rounded"
                  >
                    Verify Your Email
                  </button> -->
          </form>
          <p class="w-full mb-2 mt-4 text-grayDark">
            By clicking "Create account" above, you acknowledge that you have
            read, understood, and agree with Company's Privacy Policy and Terms
            Of Service
          </p>
          <hr class="w-full border-t-[1px] border-grayLight mb-6" />
          <p class="mt-6 text-primaryDark flex justify-between items-center">
            Don't have an account?
            <router-link
              to="/signup"
              class="text-primaryDark hover:u px-3 py-3 bg-[#EEEEEE] rounded-md"
              >Sign Up</router-link
            >
          </p>
        </div>
      </div>
      <div class="hidden md:block bg-[#F3F4F6] w-full py-20">
        <p class="mb-2 -ml-8 mt-4 h-[60px] px-[68px] font-bold text-[64px]">
          "
        </p>
        <p class="mb-2 mt- font-bold text-5 px-[68px]">
          I can confidently say it has been a game changer for our team.
          Overall, this tool has significantly enhanced our productivity and
          collaboration!
        </p>
        <p class="mb-8 mt-4 text-5 px-[68px]">- Manuel Jephtah</p>
        <img
          src="@/assets/users/Frame12.png"
          alt="Close"
          class="-mr-12 pl-[68px]"
        />
      </div>
    </div>
  </div>
</template>


<script>
import axios from "axios";
import { useRouter } from "vue-router";

export default {
  name: "LoginComponent",
  data() {
    return {
      username: "",
      password: "",
      loading: false,
      showVerifyButton: false, // Control visibility of the verify button
      showPassword: false,
    };
  },
  computed: {
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isManager() {
      return this.$store.getters.isManager;
    },
    isTalent() {
      return this.$store.getters.isTalent;
    },
    isUser() {
      return this.$store.getters.isUser;
    },
  },
  setup() {
    const router = useRouter();
    return { router };
  },
  created() {
    // Check for success message from query parameters (e.g., from reset password)
    if (this.$route.query.message) {
      this.$toast.success(this.$route.query.message);
    }
  },
  methods: {
    togglePassword() {
      this.showPassword = !this.showPassword;
    },

    async login() {
      this.loading = true;
      this.showVerifyButton = false;

      try {
        const response = await this.performLogin();

        // Extract user data directly from login response
        const token = response.access_token;
        const user = response.user;
        const userRole = user.role;

        // Save to Vuex and localStorage
        this.$store.commit("setUser", user);
        localStorage.setItem("token", token);
        // localStorage.setItem('role', userRole);
        // this.$store.commit('setUser', userData); // if userData includes role
        this.$store.commit("setRole", user.role[0]); // or just ro

        console.log("User role set:", userRole);
        console.log("Vuex store state role:", this.$store.state.role);

        if (userRole === "user") {
          this.$router.push("/awaiting-approval");
        } else {
          this.$router.push("/dashboard");
        }
      } catch (error) {
        console.error("Error logging in user:", error);

        if (
          error.status_code === 403 &&
          error.message.includes("Email is not verified")
        ) {
          this.$toast.error(error.message);
          this.showVerifyButton = true;
        } else {
          this.$toast.error(error.message || "An unexpected error occurred during login.");
          this.showVerifyButton = false;
        }
      } finally {
        this.loading = false;
      }
    },
    redirectToVerifyEmail() {
      this.$router.push({
        name: "VerifyEmail",
        params: { email: this.username },
      });
    },

    async performLogin() {
      const params = new URLSearchParams();
      params.append("username", this.username);
      params.append("password", this.password);

      try {
        const response = await axios.post(
          `${process.env.VUE_APP_API_BASE_URL}/token`,
          params,
          {
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
          }
        );
        // console.log('i just logged user in:', this.response.data)

        return response.data; // Return full response so we get user data and token
      } catch (error) {
        if (error.response && error.response.data) {
          throw error.response.data;
        } else {
          throw new Error("An unexpected error occurred during login.");
        }
      }
    },
  },
};
</script>

<style scoped>
.spinner {
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top: 2px solid white;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  animation: spin 0.6s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
